import { APP_NAME } from '@amzjp/shared';
import { pazar } from '@/lib/pazar';

/**
 * Yazılımın adı ve hangi ülkenin panelinde olunduğu (3 Kas 2026; sahip: "Yazılım adı KSKLC AMAZON
 * SELLER APP olacak. Sadece panelde hangi ülkedeysek o ülke belli olsun.").
 */
export function MarkaYazisi({ className }: { className?: string }) {
  const [ana, ...kalan] = APP_NAME.split(' ');
  return (
    <span className={className}>
      <span className="block text-[0.9375rem] font-bold leading-4 tracking-[-0.01em] text-fg">
        {ana}
      </span>
      <span className="block whitespace-nowrap text-[0.5625rem] font-semibold uppercase leading-3 tracking-[0.12em] text-fg-muted">
        {kalan.join(' ')}
      </span>
    </span>
  );
}

/** Ülke rozeti: geniş ekranda ülkenin adı, dar ekranda kısa kodu. */
export function UlkeRozeti({ uzun = false }: { uzun?: boolean }) {
  const p = pazar();
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-[var(--radius-sm)] bg-accent-soft px-1.5 py-0.5 text-[0.6875rem] font-semibold text-accent"
      title={`${p.ad} paneli (${p.amazonAlanAdi})`}
      data-testid="ulke-rozeti"
    >
      <span aria-hidden="true">{p.bayrak}</span>
      {uzun ? (
        p.ad
      ) : (
        <>
          <span className="4xl:hidden">{p.kod}</span>
          <span className="max-4xl:hidden">{p.ad}</span>
        </>
      )}
    </span>
  );
}
